import { RootState } from '../store'

export const appSelector = (state: RootState) => {
  const { app } = state

  return app
}
